import { apiClient } from "../config";

async function getCommunityProfile(communityId: string) {
  const res = await apiClient.get(`/admin/communities/${communityId}`);
  return res.data;
}

export default getCommunityProfile;
